import styles from "./NavigationPanel.module.css";

export default function NavigationPanel({ active, projects }) {

    return (
        <div>
            <div className={styles.navigationCard}>
                <ul className={styles.projectsList}>
                    {projects.map((name) => (
                        <li>
                            <a href={`#${name}`} key={name} className={active === name ? styles.activeProject : undefined}>
                                {name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div >
        </div>
    );
}
